import { FinancialAdjustment, Region } from '@cod-monorepo/interfaces';
import { GeneralCod } from '../models/cod.model';

export class CodOperations {
    public static calculateFinancialAdjustmentValue(cod: GeneralCod): number {
        if (cod.region !== Region.NAM && !cod.financialAdjustmentValue) {
            if (cod.financialAdjustmentRequest === FinancialAdjustment.NONE) {
                return 0;
            }

            const financialAdjustmentRounded = cod.affectedOrderLines
                ? cod.affectedOrderLines
                      .map(({ affectedQuantity, price }) => affectedQuantity * price)
                      .reduce((acc, nextValue) => acc + nextValue, 0)
                      .toFixed(2)
                : '0';

            return Number(financialAdjustmentRounded);
        }

        return cod.financialAdjustmentValue || 0;
    }
}
